import { render, staticRenderFns } from "./DeDate.vue?vue&type=template&id=2142f37a&scoped=true&"
import script from "./DeDate.vue?vue&type=script&lang=js&"
export * from "./DeDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2142f37a",
  null
  
)

export default component.exports